import { Text } from "react-native-paper";
import Svg, { NumberProp, Path } from "react-native-svg";

import { Carrier } from "../../delivery";

type Props = LogotypeProps & {
  carrier: Carrier | null;
};

export default function Logotype({ carrier, ...props }: Props) {
  switch (carrier) {
    case "multientrega":
      return <Multientrega {...props} />;
    case "pedidosya":
      return <PedidosYa {...props} />;
    default:
      return <Text>{carrier}</Text>;
  }
}
const disabledColor = "rgba(131, 132, 133, 1)";

type LogotypeProps = {
  disabled?: boolean;
  /**
   * Width of the logo. If only width is provided, height will be calculated based on aspect ratio.
   * If neither width nor height is provided, uses a default width based on the logo.
   */
  width?: NumberProp;
  /**
   * Height of the logo. If only height is provided, width will be calculated based on aspect ratio.
   */
  height?: NumberProp;
};

function Multientrega({ disabled, width, height }: LogotypeProps) {
  const fill = disabled ? disabledColor : "#26336D";

  const defaults = { width: 175, height: 20 };
  const dimensions = calculateDimensions({ width, height, defaults });

  return (
    <Svg
      width={dimensions.width}
      height={dimensions.height}
      fill="none"
      viewBox={viewBox(defaults)}
      preserveAspectRatio="xMinYMid meet"
    >
      <Path
        fill={fill}
        d="M135.97 8.242h-1.581c.591-3.585 2.718-5.566 6.376-5.947 1.976-.204 3.757.234 5.34 1.316.085.06.092.126.02.2l-.871.879c-.058.057-.122.066-.191.024-3.458-2.025-8.285-.872-9.093 3.528Z"
      />
      <Path
        fill={fill}
        d="M155.658 8.242h-2.4l-2.037-2.31a.05.05 0 0 0-.088.034l-.002 2.276-1.662.004.068-5.654c.002-.086.043-.139.126-.16.415-.106.781.03 1.102.409.894 1.063 2.526 2.863 4.893 5.4Z"
      />
      <Path
        fill={fill}
        d="M38.842 14.196h7.585c.059 0 .106.048.106.108v1.325c0 .059-.047.107-.106.107h-9.221a.108.108 0 0 1-.107-.107v-13.1c0-.06.048-.108.107-.108h1.422c.059 0 .107.048.107.107v11.56c0 .06.048.108.107.108Z"
      />
      <Path
        fill={fill}
        d="M61.912 15.622c0 .064-.05.114-.113.114h-1.357a.113.113 0 0 1-.114-.114V2.535c0-.064.05-.114.114-.114h1.357c.063 0 .113.05.113.114v13.087Z"
      />
      <Path
        fill={fill}
        d="M67.298 14.14h8.534c.052 0 .096.045.096.098v1.402a.097.097 0 0 1-.096.096H65.717a.097.097 0 0 1-.096-.097V2.518c0-.053.043-.097.096-.097h9.897c.052 0 .096.044.096.097v1.346a.097.097 0 0 1-.096.097h-8.316a.097.097 0 0 0-.096.097v4.704c0 .052.044.096.096.096h6.734c.052 0 .096.044.096.097v1.347a.097.097 0 0 1-.096.097h-6.734a.097.097 0 0 0-.096.097v3.548c0 .053.044.097.096.097Z"
      />
      <Path
        fill={fill}
        d="M81 6.061v9.565c0 .073-.038.11-.11.11h-1.335c-.091 0-.137-.046-.137-.136V2.595c0-.058.026-.097.078-.117.389-.156.696-.108.923.143 2.888 3.211 5.779 6.427 8.671 9.647.033.037.094.013.094-.038l-.007-9.67c0-.093.046-.14.138-.14h1.31c.09 0 .136.047.136.14v13.038c0 .092-.046.138-.137.138h-.565a.286.286 0 0 1-.223-.099l-8.695-9.631C81.047 5.9 81 5.918 81 6.061Z"
      />
      <Path
        fill={fill}
        d="m109.314 4.102-.022 5.859c0 .086.07.156.155.156l4.664.016c1.706.006 3.091-1.35 3.097-3.031v-.088c.007-1.68-1.372-3.046-3.075-3.053l-4.664-.015a.155.155 0 0 0-.155.156Zm5.685 7.589 4.561 3.878c.133.112.113.167-.059.167h-1.902a.296.296 0 0 1-.197-.072l-4.587-3.927a.293.293 0 0 0-.196-.072h-3.207c-.072 0-.109.037-.109.11v3.796c0 .11-.055.165-.164.165h-1.308c-.072 0-.11-.037-.11-.11v-13.1c0-.057.046-.103.101-.103 2.14-.011 4.286 0 6.439.035 5.635.092 6.42 8.179.781 9.075-.128.02-.144.072-.043.158Z"
      />
      <Path
        fill={fill}
        d="M123.425 14.14h8.512c.059 0 .107.049.107.108v1.38c0 .06-.048.108-.107.108h-10.093a.108.108 0 0 1-.107-.107v-13.1c0-.06.048-.108.107-.108h9.875c.059 0 .107.048.107.107v1.325c0 .06-.048.108-.107.108h-8.294a.108.108 0 0 0-.107.108v9.964c0 .06.048.108.107.108Z"
      />
      <Path
        fill={fill}
        d="M52.641 4.076v11.546c0 .064-.05.114-.113.114h-1.355a.113.113 0 0 1-.113-.114V4.076a.113.113 0 0 0-.114-.115h-4.79a.113.113 0 0 1-.113-.114V2.59c0-.064.05-.114.113-.114h11.39c.062 0 .113.05.113.114v1.257c0 .064-.05.114-.114.114h-4.79a.113.113 0 0 0-.114.115Z"
      />
      <Path
        fill={fill}
        d="M100.032 4.087V15.61a.126.126 0 0 1-.124.125H98.52a.126.126 0 0 1-.124-.125V4.087a.126.126 0 0 0-.124-.126h-4.333a.126.126 0 0 1-.124-.125V2.6c0-.068.057-.125.124-.125h10.55c.067 0 .124.057.124.125v1.235a.126.126 0 0 1-.124.125h-4.333a.126.126 0 0 0-.124.126Z"
      />
      <Path
        fill={fill}
        d="M24.024 10.178c.013 5.524 7.942 5.392 7.947.057.002-2.515.002-5.033.002-7.549 0-.103.05-.154.152-.154h1.276c.1 0 .151.05.151.152.004 1.882.004 3.761.002 5.639-.002 1.996-.118 3.328-.342 3.994-1.874 5.536-10.757 4.255-10.776-1.919-.01-2.568-.011-5.141-.005-7.714 0-.101.05-.152.15-.152h1.277c.098 0 .148.05.15.152.003 2.502.01 5 .016 7.494Z"
      />
      <Path
        fill={fill}
        d="m17.663 5.423-4.677 6.871a.353.353 0 0 1-.15.125c-.37.161-.629.133-.777-.085A1418.743 1418.743 0 0 0 7.382 5.52a.062.062 0 0 0-.114.035v10.124c0 .073-.037.11-.109.11H5.822c-.09 0-.135-.046-.135-.139V2.777c0-.092.046-.139.135-.139h1.394a.24.24 0 0 1 .212.115l4.978 7.646c.041.062.13.06.17-.002l4.927-7.662a.203.203 0 0 1 .18-.097h1.5c.092 0 .138.047.138.137v12.878c0 .09-.046.136-.138.136h-1.28c-.11 0-.164-.055-.164-.165V5.447c0-.042-.052-.06-.076-.024Z"
      />
      <Path
        fill={disabled ? disabledColor : "#DF3D29"}
        d="m157.494 10.308-2.382-.01h-20.723l-9.847-.007a.078.078 0 0 1-.076-.077l-.002-1.847c0-.077.037-.116.113-.116l9.812-.007h1.581l13.499.004 1.662-.004h14.62c.085.002.098-.029.037-.09l-3.423-3.45c-.054-.054-.054-.11 0-.164l1.05-1.061c.063-.064.128-.064.192 0l5.643 5.696c.063.064.063.128 0 .191l-5.672 5.723c-.063.064-.126.064-.19 0l-1.09-1.1c-.046-.047-.046-.09 0-.137l3.435-3.467c.035-.035.009-.096-.041-.096l-8.198.02Z"
      />
      <Path
        fill={fill}
        d="M134.389 10.297h1.581c.757 4.47 6.636 5.118 9.655 2.668a.217.217 0 0 0 .088-.185l-.035-2.483h1.581v3.069a.259.259 0 0 1-.072.184c-2.111 2.237-4.982 2.785-7.912 2.109-2.833-.654-4.463-2.44-4.886-5.362Z"
      />
      <Path
        fill={fill}
        d="M149.55 10.298h1.581l-.006 5.324c0 .077-.037.114-.114.114h-1.341c-.077 0-.114-.037-.116-.114l-.004-5.324Z"
      />
      <Path
        fill={fill}
        d="m155.112 10.298 2.382.01 4.568 5.332c.033.037.004.094-.044.094l-1.834.002a.283.283 0 0 1-.218-.094l-4.854-5.344Z"
      />
    </Svg>
  );
}

function PedidosYa({ disabled, width, height }: LogotypeProps) {
  const fill = disabled ? disabledColor : "#FA0050";

  const defaults = { width: 161, height: 37 };
  const dimensions = calculateDimensions({ width, height, defaults });

  return (
    <Svg
      width={dimensions.width}
      height={dimensions.height}
      viewBox={viewBox(defaults)}
      preserveAspectRatio="xMinYMid meet"
      fill="none"
    >
      <Path
        fill={fill}
        d="M94.866 10c-1.327 0-2.323.998-2.36 2.402-.037 1.109.664 1.774 1.844 1.774 1.328 0 2.323-.998 2.36-2.402 0-1.109-.663-1.774-1.844-1.774ZM90.736 10.591a.203.203 0 0 0-.184-.11h-2.913c-.111 0-.222.073-.259.221 0 0-1.143 5.618-1.217 6.024-.737-1.293-2.175-2.106-3.982-2.106-3.577 0-6.159 2.882-6.159 6.837 0 3.252 1.955 5.432 4.868 5.432 1.401 0 2.618-.554 3.54-1.589-.074.296-.11.591-.184.924 0 .074 0 .148.074.222.036.074.11.11.184.11h2.913c.11 0 .222-.073.258-.221l3.098-15.522c.037-.11 0-.185-.037-.222Zm-5.642 10.163a3.84 3.84 0 0 1-.406 1.146 4.352 4.352 0 0 1-.7.924c-.258.259-.59.443-.922.591-.664.259-1.438.296-2.028.037-.259-.11-.517-.259-.701-.48a2.66 2.66 0 0 1-.443-.776 2.361 2.361 0 0 1-.11-1.035c.037-.444.11-.887.295-1.294.184-.406.405-.776.7-1.071.295-.296.627-.555.996-.703.369-.184.775-.258 1.217-.258.369 0 .7.074.996.222.295.147.553.332.737.59.185.26.332.555.406.888.037.37.037.776-.037 1.22ZM95.309 15.876h-3.024a.277.277 0 0 0-.258.185l-2.028 10.2c0 .074 0 .148.073.185.037.037.111.074.222.074h3.024c.11 0 .22-.074.258-.185l2.065-10.163c0-.074 0-.148-.074-.185a.398.398 0 0 0-.258-.11ZM51.278 25.596c.295-1.368.885-4.435.885-4.509.147 0 3.577.037 3.577.037 4.093 0 6.638-2.18 6.638-5.728 0-3.105-2.102-4.916-5.642-4.916H50.65c-.11 0-.221.074-.258.222l-3.098 15.411c0 .074 0 .148.074.222.037.074.11.11.221.11h2.729c-.074 0 .774 0 .959-.85Zm4.572-7.798h-3.023c.036-.074.774-3.88.81-4.028.148 0 2.804.037 2.804.037 1.327 0 2.065.628 2.065 1.773 0 1.405-.96 2.218-2.656 2.218ZM117.767 14.62c-3.983 0-6.859 2.845-6.859 6.763 0 3.363 2.286 5.506 5.827 5.506 3.982 0 6.859-2.846 6.859-6.763 0-3.363-2.287-5.506-5.827-5.506Zm-.811 8.795c-1.512 0-2.397-.85-2.397-2.254 0-1.774 1.254-3.068 2.95-3.068 1.512 0 2.397.85 2.397 2.255 0 1.774-1.217 3.067-2.95 3.067ZM111.314 10.591a.203.203 0 0 0-.185-.11h-2.913c-.11 0-.221.073-.258.221 0 0-1.143 5.618-1.217 6.024-.738-1.293-2.176-2.106-3.983-2.106-3.577 0-6.158 2.882-6.158 6.837 0 3.252 1.954 5.432 4.867 5.432 1.402 0 2.619-.554 3.54-1.589-.073.296-.11.591-.184.924 0 .074 0 .148.074.222.037.074.11.11.184.11h2.914c.11 0 .22-.073.258-.221l3.097-15.522c.037-.11 0-.185-.036-.222Zm-5.569 10.163a3.84 3.84 0 0 1-.405 1.146 4.352 4.352 0 0 1-.701.924c-.258.259-.59.443-.922.591-.664.259-1.438.296-2.028.037-.258-.11-.517-.259-.701-.48a2.66 2.66 0 0 1-.442-.776c-.111-.296-.148-.666-.111-1.035.037-.444.11-.887.295-1.294.184-.406.406-.776.7-1.071.296-.296.627-.555.996-.703.369-.184.775-.258 1.217-.258.369 0 .7.074.996.222.295.147.553.332.737.59.185.26.332.555.406.888.037.37.037.776-.037 1.22ZM133.255 15.507c-1.511-.703-3.097-.998-4.535-.887-2.508.221-3.946 1.737-3.762 3.917.11 1.33.885 2.328 2.323 3.104l1.586.85c.664.333.7.518.738.702.037.48-.517.592-.812.629-.995.074-2.212-.296-3.503-1.109-.074-.037-.147-.037-.184-.037-.074 0-.111.074-.148.111l-1.29 2.254a.241.241 0 0 0 .073.333 8.207 8.207 0 0 0 5.274 1.404c2.802-.258 4.277-1.737 4.093-4.065-.11-1.404-.811-2.291-2.36-3.104l-1.438-.74c-.849-.48-.885-.59-.922-.812 0-.111-.037-.48.774-.555.811-.074 1.844.185 2.877.665.073.037.147.037.184 0a.288.288 0 0 0 .147-.147l.996-2.292c.074-.037.037-.185-.11-.221ZM149.113 10.96c-.037-.11-.148-.147-.259-.147h-4.13c-.11 0-.184.037-.221.11 0 0-4.13 5.84-4.388 6.394-.074-.517-2.102-6.32-2.102-6.32-.037-.11-.148-.22-.259-.22h-3.613c-.074 0-.185.036-.222.11-.037.074-.073.185-.037.259l3.836 9.756-1.144 5.655c0 .073 0 .184.074.221.037.074.148.111.221.111h2.914c.368 0 .7-.259.774-.665l1.033-5.248 7.56-9.793c0-.037 0-.148-.037-.222ZM157.89 15.359a.203.203 0 0 0-.185-.111h-2.84c-.11 0-.22.074-.258.222l-.184.923a3.932 3.932 0 0 0-2.655-1.33 5.9 5.9 0 0 0-2.655.407c-2.803 1.071-4.684 3.843-4.647 6.873.037 2.624 1.733 4.398 4.388 4.546 1.402.074 2.656-.37 3.762-1.293a10.22 10.22 0 0 0-.184.924c0 .073 0 .147.073.221.037.074.11.074.185.074h2.84c.11 0 .22-.074.257-.222l2.176-11.05c0-.036-.037-.11-.074-.184Zm-4.426 5.691c-.074.407-.184.776-.369 1.109a3.978 3.978 0 0 1-.663.887 2.861 2.861 0 0 1-.885.591 2.745 2.745 0 0 1-1.955.037 1.707 1.707 0 0 1-.664-.48 1.602 1.602 0 0 1-.405-.74 2.096 2.096 0 0 1-.111-.96c.037-.444.11-.85.295-1.257.147-.37.406-.74.664-1.035.258-.295.59-.517.959-.702a2.466 2.466 0 0 1 1.143-.259c.369 0 .664.074.959.185.295.148.516.333.7.554.185.222.332.518.369.85.037.407.037.813-.037 1.22ZM69.348 14.583c-3.91 0-6.749 2.845-6.749 6.8 0 3.4 2.286 5.506 5.937 5.506 1.66 0 3.024-.443 4.462-1.404.148-.074.148-.259.037-.37l-1.807-1.848c-.074-.074-.184-.11-.295-.037a4.967 4.967 0 0 1-2.36.592c-1.66 0-2.655-.776-2.692-2.107l8.224-.037c.11 0 .22-.074.258-.221.184-.85.295-1.442.295-2.107.037-2.92-2.028-4.767-5.31-4.767Zm-3.061 4.545c.553-1.293 1.512-1.958 2.987-1.958s2.212.665 2.286 1.995c-.258 0-5.015-.037-5.273-.037ZM27.127 1H3.625A.62.62 0 0 0 3 1.627V5.02c0 3.688 2.611 5.717 7.356 5.717l16.808.036c1.765 0 3.2 1.439 3.2 3.21a3.207 3.207 0 0 1-3.2 3.208H8.296a.63.63 0 0 0-.588.442l-4.45 17.63a.641.641 0 0 0 .11.516c.11.147.294.221.478.221h5.958c2.244 0 3.31-1.844 3.568-2.84l1.765-6.343h11.99c7.099 0 12.873-5.79 12.873-12.909C40 6.79 34.226 1 27.127 1Z"
      />
    </Svg>
  );
}
type Dimensions = { width: number; height: number };

function viewBox({ width, height }: Dimensions) {
  return `0 0 ${width} ${height}`;
}

type CalculateDimensionParams = {
  width?: NumberProp;
  height?: NumberProp;
  defaults: Dimensions;
};

function calculateDimensions({
  width,
  height,
  defaults,
}: CalculateDimensionParams) {
  const aspectRatio = defaults.width / defaults.height;

  function convert(value: NumberProp, ratio: number) {
    return typeof value === "number" ? value * ratio : value;
  }

  if (width && height) {
    return { width, height };
  } else if (width) {
    return { width, height: convert(width, 1 / aspectRatio) };
  } else if (height) {
    return { width: convert(height, aspectRatio), height };
  } else {
    return defaults;
  }
}
